<template>
  <div class="leads_search">
    <div class="leads_search_box" v-if="newDialog">
      <div class="newHhuokeBox">
        <div class="newHuo-left">
          <div class="newHuo-left-box margin-bottom30">
            <div class="flex_center margin-bottom20">
              <img class="leads_search_logo" src="../../../assets/dialogIcoImg/LeableLogo.png" alt="" />
            </div>
            <h3 class="newHuo-left-head margin-bottom20">Search Leads</h3>
            <div class="newHuo_con">
              <div class="newHuo-left-head_text margin-bottom20">
                "Search Leads", a powerful tool, assists business users in connecting with potential customers or
                vendors. Utilizing cutting-edge machine learning technology, our platform analyzes extensive datasets to
                provide personalized and precise recommendations.
              </div>
              <div class="newHuo-left-head_text margin-bottom20">
                The system considers user objectives, market trends, risk tolerance, and historical data to identify
                products or services that align with their specific needs and preferences.
              </div>
              <div class="newHuo-left-head_text margin-bottom20">
                "Search Leads" continuously learns and evolves, ensuring its recommendations remain relevant and
                accurate. By offering actionable insights, it empowers businesses to save time and resources while
                identifying the most promising customers or vendors.
              </div>
              <div class="newHuo-left-head_text">
                <!-- v-if="questionsNum==3" -->
                To generate a list of recommended companies, we kindly request you to answer a few questions.
              </div>
            </div>
          </div>
          <div class="flex_center">
            <el-button class="btn_export btn_exportYell riskButton" @click="onSubmitkoudian()">
              <span>Let's Begin</span></el-button>
          </div>
        </div>
        <!-- <div class="newHuo-right">
            <img src="../../../assets/dialogIcoImg/newHuoke.png" alt="">
         </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    suoClose: {
      type: Boolean,
    },
  },
  data() {
    return {
      //page: this.currentPage
      questionsNum: 0,
      token: localStorage.getItem("token"),
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.suoClose;
      },
      set() { },
    },
  },
  destroyed() {
    // bus.$off('handleShowLogin');
  },
  methods: {
    //关闭弹窗
    closeDialog() {
      this.$emit("closeCloseDialog", false);
    },
    onSubmitkoudian() {
      if (this.token) {
        this.$emit("closeCloseDialog", false);
      } else {
        this.$parent.$parent.loginDialog = true;
      }
    },
    onSubmitquxiao() { },
  },
};
</script>
<style scoped>
.leads_search {
  height: 100%;
  background: #ffffff;
}

.leads_search_box {
  height: 100%;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: center;
  border-radius: 4px;
}

.detail_cont {
  max-height: 85vh;
  overflow: auto;
  min-height: 216px;
  margin-bottom: 2.14285714rem;
}

.btn_exportYell {
  background: #8e86dd !important;
  border-radius: 10px;
}

.dialog_normal_question-head {
  font-size: 1.857142857143rem;
  color: #1a2332;
  text-align: center;
}

.newHuo-right {
  width: 100%;
  text-align: right;
  position: relative;
  top: -11%;
}

.newHuo-right img {
  width: 40%;
  height: 30%;
}

.newHuo-left {
  z-index: 999;
  position: relative;
  /* width: 58.5714rem; */
}

.newHhuokeBox {
  width: 800px;
  background: #f5f5f5;
  padding: 30px 50px;
  position: relative;
  overflow: visible;
}

.newHuo-left-head {
  font-size: 26px;
  font-family: "Arial Bold";
  text-align: center;
}

.newHuo-left-head_text {
  font-size: 18px;
  line-height: 28px;
}

.leads_search_logo {
  width: 120px;
}

@media screen and (max-width: 1920px) {
  .newHhuokeBox {
    width: 600px;
    border-radius: 22px;
    padding: 22px 38px;
  }

  .newHuo-left-head {
    font-size: 20px;
  }

  .newHuo-left-head_text {
    font-size: 16px;
    line-height: 24px;
  }

  .leads_search_logo {
    width: 80px;
  }

  .leads_search_box {
    border-radius: 22px;
  }
}

@media screen and (max-width: 1439px) {
  .newHhuokeBox {
    width: 510px;
    padding: 20px 32px;
  }

  .newHuo-left-head_text ::v-deep {
    font-size: 14px;
    line-height: 21px;
  }

  .Close-Icon ::v-deep {
    right: 36px;
    top: 36px;
  }
}
</style>
